import { SponsoredCard } from "@models/sponsored-card.model";
import { BaseConverter } from "./BaseConverter";
import { SponsoredCardDto } from "@dtos/sponsored-card.dto";
import { CardInfoConverter } from "./cardInfoConverter";

export class SponsoredCardConverter extends BaseConverter<SponsoredCard, SponsoredCardDto>{
    private cardInfoConverter = new CardInfoConverter()
    modelToDto(model: SponsoredCard): SponsoredCardDto {
        return new SponsoredCardDto(
            model.id,
            model.displaySorting,
            model.active,
            model.startDateSponsorship?.toISOString(),
            model.endDateSponsorship?.toISOString(),
            model.photo,
            model.link
        )
    }

    dtoToModel(dto: SponsoredCardDto): SponsoredCard {
       return new SponsoredCard(
            dto.id,
            dto.displaySorting,
            dto.active,
            dto.startDateSponsorship?new Date(dto.startDateSponsorship) : undefined,
            dto.endDateSponsorship? new Date(dto.endDateSponsorship) : undefined,
            dto.photo,
            dto.link
       )
    }
}